/* SanitairLuxe verkoopadviseur (chat). Verplaatst uit snippets/verkoopadviseur.liquid (SL 24/10 snelheid),
   zodat de browser dit bestand bewaart in plaats van het bij elke pagina opnieuw mee te sturen.
   Wordt met defer geladen: de HTML van het chatvenster staat dan al in de pagina. */
(function () {
  var root = document.getElementById('sl-adviseur');
  if (!root) { return; }
  var endpoint = (root.dataset.endpoint || '').replace(/\/+$/, '') + '/api/advies';
  var naam = root.dataset.naam || 'Adviseur';
  var taal = root.dataset.lang || 'nl-NL';
  var T = {
    uit: root.dataset.tUit || 'Op dit moment niet op voorraad',
    typt: root.dataset.tTypt || 'typt',
    wacht: root.dataset.tWacht || 'Even geduld, de adviseur wordt opgestart…',
    druk: root.dataset.tDruk || 'Het is even druk, probeer het zo nog eens.',
    fout: root.dataset.tFout || 'Sorry, het advies lukt nu even niet. Bel of mail ons gerust.'
  };
  var welkom = root.querySelector('template.sl-sjabloon-welkom');
  var suggesties = root.querySelector('template.sl-sjabloon-suggesties');
  var knop = root.querySelector('.sl-knop');
  var venster = root.querySelector('.sl-venster');
  var gesprek = root.querySelector('.sl-gesprek');
  var formulier = root.querySelector('.sl-formulier');
  var verzend = formulier.querySelector('.sl-stuur');
  var postcodeKnop = formulier.querySelector('.sl-postcode-knop');
  var postcodeVak = formulier.querySelector('.sl-postcode');
  var kopFoto = root.querySelector('.sl-kop-foto');
  var begonnen = false;
  var bezig = false;
  var OPSLAG = 'sl-adviseur-gesprek-' + taal;
  var mobiel = window.matchMedia('(max-width: 767px)');
  var metMuis = window.matchMedia('(hover: hover) and (pointer: fine)');

  function focusInvoer() {
    if (metMuis.matches && !mobiel.matches) {
      try { formulier.vraag.focus({ preventScroll: true }); } catch (e) { formulier.vraag.focus(); }
    }
  }

  /* ---- gesprek bewaren ---- */
  function bewaar() {
    try {
      var kopie = gesprek.cloneNode(true);
      Array.prototype.forEach.call(kopie.querySelectorAll('.sl-typt'), function (el) {
        var rij = el.closest('.sl-bericht');
        (rij || el).remove();
      });
      sessionStorage.setItem(OPSLAG, kopie.innerHTML);
    } catch (e) {}
  }
  function herstel() {
    try {
      var html = sessionStorage.getItem(OPSLAG);
      if (html) { gesprek.innerHTML = html; begonnen = true; }
    } catch (e) {}
  }
  function wisOpslag() {
    try { sessionStorage.removeItem(OPSLAG); } catch (e) {}
  }

  function klok() {
    return new Date().toLocaleTimeString(taal, { hour: '2-digit', minute: '2-digit' });
  }
  function naarBeneden() { gesprek.scrollTop = gesprek.scrollHeight; }
  function wacht(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function avatar() {
    var el;
    if (kopFoto && kopFoto.tagName === 'IMG') {
      el = document.createElement('img');
      el.src = kopFoto.src; el.alt = ''; el.loading = 'lazy';
    } else {
      el = document.createElement('span');
      el.textContent = naam.slice(0, 1);
      el.setAttribute('aria-hidden', 'true');
    }
    el.className = 'sl-avatar';
    return el;
  }

  function bericht(vanKlant) {
    var rij = document.createElement('div');
    rij.className = 'sl-bericht ' + (vanKlant ? 'sl-van-klant' : 'sl-van-adviseur');
    if (!vanKlant) { rij.appendChild(avatar()); }
    var regel = document.createElement('div');
    regel.className = 'sl-regel';
    if (!vanKlant) {
      var afzender = document.createElement('span');
      afzender.className = 'sl-afzender';
      afzender.textContent = naam;
      regel.appendChild(afzender);
    }
    var bubbel = document.createElement('div');
    bubbel.className = 'sl-bubbel';
    regel.appendChild(bubbel);
    var tijd = document.createElement('time');
    tijd.className = 'sl-tijd';
    tijd.textContent = klok();
    regel.appendChild(tijd);
    rij.appendChild(regel);
    gesprek.appendChild(rij);
    naarBeneden();
    return { rij: rij, bubbel: bubbel, regel: regel };
  }

  function render(regel, doel) {
    var patroon = /\*\*\[([^\]]+)\]\(([^)]+)\)\*\*|\*\*([^*]+)\*\*|\[([^\]]+)\]\(([^)]+)\)/g;
    var index = 0, match;
    while ((match = patroon.exec(regel)) !== null) {
      doel.appendChild(document.createTextNode(regel.slice(index, match.index)));
      var label = match[1] || match[3] || match[4];
      var href = match[2] || match[5];
      if (href && /^(https?:\/\/|mailto:|tel:)/i.test(href)) {
        var a = document.createElement('a');
        a.href = href; a.textContent = label;
        if (/^https?:/i.test(href)) { a.target = '_blank'; a.rel = 'noopener noreferrer'; }
        if (match[1]) { var b = document.createElement('strong'); b.appendChild(a); doel.appendChild(b); }
        else { doel.appendChild(a); }
      } else {
        var sterk = document.createElement('strong');
        sterk.textContent = label;
        doel.appendChild(sterk);
      }
      index = patroon.lastIndex;
    }
    doel.appendChild(document.createTextNode(regel.slice(index)));
  }

  function vulBubbel(bubbel, tekst) {
    var lijst = null;
    String(tekst || '').split('\n').forEach(function (regel) {
      var item = /^\s*-\s+(.*)$/.exec(regel);
      if (item) {
        if (!lijst) { lijst = document.createElement('ul'); bubbel.appendChild(lijst); }
        var li = document.createElement('li');
        render(item[1], li);
        lijst.appendChild(li);
        return;
      }
      lijst = null;
      if (!regel.trim()) { return; }
      var p = document.createElement('p');
      render(regel, p);
      bubbel.appendChild(p);
    });
  }

  function kaarten(producten, regel) {
    if (!producten || !producten.length) { return; }
    var lijst = document.createElement('div');
    lijst.className = 'sl-kaarten';
    producten.forEach(function (product) {
      if (!product.link || !/^https?:\/\//i.test(product.link)) { return; }
      var kaart = document.createElement('a');
      kaart.className = 'sl-kaart';
      kaart.href = product.link;
      kaart.target = '_blank'; kaart.rel = 'noopener noreferrer';
      var tekst = document.createElement('span');
      tekst.className = 'sl-kaart-tekst';
      var titel = document.createElement('span');
      titel.className = 'sl-kaart-titel';
      titel.textContent = product.titel;
      tekst.appendChild(titel);
      if (product.prijs) {
        var prijs = document.createElement('span');
        prijs.className = 'sl-kaart-prijs';
        prijs.textContent = product.prijs;
        tekst.appendChild(prijs);
      }
      if (product.op_voorraad === false) {
        var uit = document.createElement('span');
        uit.className = 'sl-kaart-uit';
        uit.textContent = T.uit;
        tekst.appendChild(uit);
      }
      kaart.appendChild(tekst);
      var pijl = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      pijl.setAttribute('viewBox', '0 0 24 24');
      pijl.setAttribute('width', '18'); pijl.setAttribute('height', '18');
      pijl.setAttribute('aria-hidden', 'true');
      pijl.setAttribute('class', 'sl-kaart-pijl');
      var pad = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      pad.setAttribute('d', 'M9 5l7 7-7 7');
      pad.setAttribute('fill', 'none'); pad.setAttribute('stroke', 'currentColor');
      pad.setAttribute('stroke-width', '2'); pad.setAttribute('stroke-linecap', 'round');
      pad.setAttribute('stroke-linejoin', 'round');
      pijl.appendChild(pad);
      kaart.appendChild(pijl);
      lijst.appendChild(kaart);
    });
    if (lijst.children.length) { regel.insertBefore(lijst, regel.querySelector('.sl-tijd')); }
  }

  function typtBericht() {
    var blok = bericht(false);
    var stippen = document.createElement('div');
    stippen.className = 'sl-typt';
    stippen.setAttribute('aria-label', naam + ' ' + T.typt);
    for (var i = 0; i < 3; i += 1) { stippen.appendChild(document.createElement('span')); }
    blok.bubbel.appendChild(stippen);
    return blok;
  }

  function toonSuggesties() {
    if (!suggesties) { return; }
    var rij = document.createElement('div');
    rij.className = 'sl-suggesties';
    Array.prototype.forEach.call(
      suggesties.content.querySelectorAll('button'), function (voorbeeld) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.textContent = voorbeeld.textContent.trim();
        rij.appendChild(chip);
      });
    if (rij.children.length) { gesprek.appendChild(rij); naarBeneden(); }
  }
  gesprek.addEventListener('click', function (event) {
    var chip = event.target.closest && event.target.closest('.sl-suggesties button');
    if (!chip) { return; }
    var rij = chip.closest('.sl-suggesties');
    var tekst = chip.textContent;
    if (rij) { rij.remove(); }
    stuur(tekst);
  });

  function begin() {
    begonnen = true;
    if (welkom) {
      bericht(false).bubbel.appendChild(welkom.content.cloneNode(true));
      naarBeneden();
    }
    toonSuggesties();
    bewaar();
  }

  function opnieuw() {
    wisOpslag();
    gesprek.textContent = '';
    begin();
    focusInvoer();
  }

  /* ---- telefoon: pagina vastzetten + meebewegen met het toetsenbord ---- */
  var vv = window.visualViewport;
  var bewaardeScroll = 0;

  function pasHoogteAan() {
    if (!root.classList.contains('sl-open') || !mobiel.matches) { return; }
    var h = vv ? vv.height : window.innerHeight;
    var top = vv ? vv.offsetTop : 0;
    root.style.setProperty('--sl-chat-h', Math.round(h) + 'px');
    root.style.setProperty('top', Math.round(top) + 'px', 'important');
    naarBeneden();
  }
  /* Het toetsenbord animeert; meerdere keren meten vangt de eindstand. */
  function pasHoogteAanNaAnimatie() {
    pasHoogteAan();
    [60, 180, 350, 600, 900].forEach(function (ms) { setTimeout(pasHoogteAan, ms); });
  }

  function vergrendel(aan) {
    var html = document.documentElement;
    var body = document.body;
    if (aan && mobiel.matches) {
      if (html.classList.contains('sl-chat-lock')) { return; }
      bewaardeScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
      html.classList.add('sl-chat-lock');
      body.style.position = 'fixed';
      body.style.top = (-bewaardeScroll) + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
    } else if (html.classList.contains('sl-chat-lock')) {
      html.classList.remove('sl-chat-lock');
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      window.scrollTo(0, bewaardeScroll);
    }
  }

  if (vv) {
    vv.addEventListener('resize', pasHoogteAan);
    vv.addEventListener('scroll', pasHoogteAan);
  }
  window.addEventListener('resize', pasHoogteAan);
  root.addEventListener('focusin', pasHoogteAanNaAnimatie);
  root.addEventListener('focusout', pasHoogteAanNaAnimatie);

  function open() {
    venster.hidden = false;
    knop.setAttribute('aria-expanded', 'true');
    root.classList.add('sl-open');
    vergrendel(true);
    if (!begonnen) { begin(); }
    pasHoogteAanNaAnimatie();
    naarBeneden();
    focusInvoer();
  }

  function sluit() {
    if (document.activeElement && root.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    venster.hidden = true;
    knop.setAttribute('aria-expanded', 'false');
    root.classList.remove('sl-open');
    root.style.removeProperty('--sl-chat-h');
    root.style.removeProperty('top');
    vergrendel(false);
    bewaar();
  }

  knop.addEventListener('click', open);
  root.querySelector('.sl-sluit').addEventListener('click', sluit);
  root.querySelector('.sl-opnieuw').addEventListener('click', opnieuw);
  venster.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') { sluit(); }
  });

  postcodeKnop.addEventListener('click', function () {
    var tonen = postcodeVak.hidden;
    postcodeVak.hidden = !tonen;
    postcodeKnop.setAttribute('aria-expanded', String(tonen));
    if (tonen) { formulier.postcode.focus(); } else { focusInvoer(); }
  });

  function winkelwagen() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { return cart && cart.items ? cart.items.length : 0; })
      .catch(function () { return 0; });
  }

  /* Server op gratis hosting slaapt na een tijdje; eerste verzoek kan mislukken
     of lang duren. Daarom tot 3x proberen, met een melding voor de klant. */
  function vraagAan(payload, poging, wachtBlok) {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (r.status === 429) { throw new Error('druk'); }
      if (r.status >= 500 && poging < 2) { return opnieuwProberen(payload, poging, wachtBlok); }
      if (!r.ok) { throw new Error('fout'); }
      return r.json();
    }, function (err) {
      if (poging < 2) { return opnieuwProberen(payload, poging, wachtBlok); }
      throw err;
    });
  }
  function opnieuwProberen(payload, poging, wachtBlok) {
    if (wachtBlok && !wachtBlok.bubbel.querySelector('.sl-wacht-tekst')) {
      var t = document.createElement('div');
      t.className = 'sl-wacht-tekst';
      t.textContent = T.wacht;
      wachtBlok.bubbel.appendChild(t);
      naarBeneden();
    }
    return wacht(poging === 0 ? 4000 : 9000).then(function () {
      return vraagAan(payload, poging + 1, wachtBlok);
    });
  }

  function stuur(vraag) {
    vraag = (vraag || '').trim();
    if (!vraag || bezig) { return; }
    bericht(true).bubbel.textContent = vraag;
    formulier.vraag.value = '';
    bewaar();
    bezig = true;
    verzend.disabled = true;
    var wachtBlok = typtBericht();

    winkelwagen().then(function (aantal) {
      return vraagAan({
        vraag: vraag,
        postcode: formulier.postcode.value.trim(),
        winkelwagen: aantal
      }, 0, wachtBlok);
    }).then(function (data) {
      wachtBlok.rij.remove();
      var blok = bericht(false);
      vulBubbel(blok.bubbel, data && data.antwoord);
      kaarten(data && data.producten, blok.regel);
      naarBeneden();
    }).catch(function (error) {
      wachtBlok.rij.remove();
      if (window.console) { console.warn('[verkoopadviseur] verzoek mislukt:', error, endpoint); }
      bericht(false).bubbel.textContent = error && error.message === 'druk'
        ? T.druk
        : T.fout;
    }).finally(function () {
      bezig = false;
      verzend.disabled = false;
      bewaar();
      focusInvoer();
    });
  }

  formulier.addEventListener('submit', function (event) {
    event.preventDefault();
    stuur(formulier.vraag.value);
  });

  herstel();
})();
